
import {downFile} from '@/utils.ts'

function exportFile(res) {
  const filename = res.headers['content-disposition']?.match(/filename="(.+?)"/)[1]
  downFile(res.data, filename || 'export-data.xlsx')
}

export {exportFile}